import { render, staticRenderFns } from "./canteen-management-list.vue?vue&type=template&id=71a1fe06&scoped=true"
import script from "./canteen-management-list.vue?vue&type=script&lang=js"
export * from "./canteen-management-list.vue?vue&type=script&lang=js"
import style0 from "./canteen-management-list.vue?vue&type=style&index=0&id=71a1fe06&prod&lang=scss&scoped=true"
import style1 from "./canteen-management-list.vue?vue&type=style&index=1&id=71a1fe06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a1fe06",
  null
  
)

export default component.exports